import React from 'react'
import CellContent from './CellContent'
import BodyText from 'LuxKit/Typography/BodyText'

interface Props {
  offer: App.HotelOffer
  packageUniqueKey: string
}

function LEHotelRoomSizeCell({ offer, packageUniqueKey }: Props) {
  const pkg = offer.packages.find(p => p.uniqueKey === packageUniqueKey)

  return (
    <CellContent>
      {pkg && <BodyText variant="medium">{pkg.roomType.sizeSqm} m&sup2;</BodyText>}
    </CellContent>
  )
}

export default LEHotelRoomSizeCell
